
    export const CHECKBOX_WIDTH =50
    export const SN_WIDTH =80
    export const ID_WIDTH =100
    export const NAME_WIDTH =160
    export const EMAIL_WIDTH =180 
    export const PHONE_WIDTH =100 

    export const RESUME_SUITABILITY_WIDTH =100
    export const CANDIDATE_STATUS_WIDTH =160
    export const RESUME_STATUS_WIDTH =165
    export const INTERVIEW_STATUS_WIDTH =165
    export const INTERVIEW_TYPE_WIDTH =165    
    export const SELECTION_STATUS_WIDTH =165
    export const OFFER_STATUS_WIDTH =165            
    export const SKILL_MATRIX_SUITABILITY_WIDTH =100
    export const EVALUTATION_SUITABILITY_WIDTH =100
    export const PAYROLL_WIDTH =80
    export const TOTAL_EXP_WIDTH =80
    export const RELEVANT_EXP_WIDTH =80
    export const SKILL_TAGS_WIDTH =100
    export const SOFT_SKILL_WIDTH =100
    export const UPDATE_BY_WIDTH =150
    export const UPDATE_ON_WIDTH =100

    export const CURRENT_LOCATION_WIDTH =100
    export const CURRENT_CTC_WIDTH =80
    export const ECTC_WIDTH =80
    export const NOTICE_PERIOD_WIDTH =80
    export const LWD_WIDTH =100

    export const REASON_LEAVING_WIDTH =100
    export const CURRENTLY_EMPLOYED_WIDTH =100
    export const REASON_NOT_WORKING_WIDTH =100
    export const OTHER_OFFERS_WIDTH =80
    export const OTHER_OFFER_DOJ_WIDTH =100
    export const OTHER_OFFER_COMPANY_TYPE =120
    export const COMMENTS_WIDTH =200
    export const EXTRA_ANA__WIDTH =100
    export const NUJOBS_COMMENTS_WIDTH =200

    export const CTC_COLUMNS_WIDTH =[
        SN_WIDTH, ID_WIDTH, NAME_WIDTH, EMAIL_WIDTH, PHONE_WIDTH, RESUME_SUITABILITY_WIDTH, CANDIDATE_STATUS_WIDTH,
        EXTRA_ANA__WIDTH,
        RESUME_STATUS_WIDTH, CURRENT_CTC_WIDTH,
        ECTC_WIDTH, 
        COMMENTS_WIDTH, NOTICE_PERIOD_WIDTH, NOTICE_PERIOD_WIDTH, LWD_WIDTH, REASON_LEAVING_WIDTH, 
        CURRENTLY_EMPLOYED_WIDTH, REASON_NOT_WORKING_WIDTH,OTHER_OFFERS_WIDTH,OTHER_OFFER_DOJ_WIDTH,
        CURRENT_CTC_WIDTH,OTHER_OFFER_COMPANY_TYPE
    ]

    export const AADHAR_ID_WIDTH =120
    export const GENDER_WIDTH =80
    export const DESIGNATION_WIDTH =100
    export const COMPANY_WIDTH =120
    export const MAX_DEGREE_WIDTH =80
    export const STREAM_WIDTH =100  
    export const PASSING_YEAR_WIDTH =80  
    
    export const PERSONAL_DETAIL_COLUMNS_WIDTH =[
        SN_WIDTH, ID_WIDTH, NAME_WIDTH, EMAIL_WIDTH, PHONE_WIDTH, RESUME_SUITABILITY_WIDTH, CANDIDATE_STATUS_WIDTH,
        EXTRA_ANA__WIDTH,
        RESUME_STATUS_WIDTH,AADHAR_ID_WIDTH, GENDER_WIDTH, CURRENT_LOCATION_WIDTH, CURRENT_LOCATION_WIDTH,
        DESIGNATION_WIDTH, COMPANY_WIDTH,MAX_DEGREE_WIDTH,STREAM_WIDTH,PASSING_YEAR_WIDTH
    ]

    //this is for Resume Status Page
    export const SKILLS_COLUMNS_WIDTH =[
        CHECKBOX_WIDTH, SN_WIDTH, ID_WIDTH, NAME_WIDTH, RESUME_SUITABILITY_WIDTH, CANDIDATE_STATUS_WIDTH,EXTRA_ANA__WIDTH,
        RESUME_STATUS_WIDTH, SKILL_MATRIX_SUITABILITY_WIDTH, EVALUTATION_SUITABILITY_WIDTH, PAYROLL_WIDTH, 
        TOTAL_EXP_WIDTH, RELEVANT_EXP_WIDTH, SKILL_TAGS_WIDTH,SOFT_SKILL_WIDTH, COMMENTS_WIDTH,
        UPDATE_BY_WIDTH, UPDATE_ON_WIDTH
    ]

    //this is for Resume Status Page
  
    export const SUMMARY_COLUMNS_WIDTH =[
        SN_WIDTH, ID_WIDTH, NAME_WIDTH, EMAIL_WIDTH, PHONE_WIDTH, RESUME_SUITABILITY_WIDTH, CANDIDATE_STATUS_WIDTH,EXTRA_ANA__WIDTH,
        RESUME_STATUS_WIDTH, CURRENT_LOCATION_WIDTH, TOTAL_EXP_WIDTH, RELEVANT_EXP_WIDTH, CURRENT_CTC_WIDTH, ECTC_WIDTH,
        NOTICE_PERIOD_WIDTH,LWD_WIDTH, COMMENTS_WIDTH,UPDATE_BY_WIDTH, UPDATE_ON_WIDTH
    ]


    export const HIRING_FLOW_COLUMNS_WIDTH =[
        SN_WIDTH, ID_WIDTH, NAME_WIDTH, EMAIL_WIDTH, PHONE_WIDTH, RESUME_SUITABILITY_WIDTH, CANDIDATE_STATUS_WIDTH,
        EXTRA_ANA__WIDTH,
        RESUME_STATUS_WIDTH, INTERVIEW_TYPE_WIDTH, INTERVIEW_STATUS_WIDTH, SELECTION_STATUS_WIDTH, OFFER_STATUS_WIDTH
    ]

    export const FINAL_ANALYSIS_WIDTH =80
    export const SKILL_ANALYSIS_WIDTH =80
    export const ROLE_ANALYSIS_WIDTH =100
    export const EDU_ANALYSIS_WIDTH =100
    export const EXP_ANALYSIS_WIDTH =80
    export const MENTIONED_EXP_WIDTH =80
    export const CUMULATIVE_EXP_WIDTH =80
    export const EXPECTED_EXP_WIDTH =100
    export const BARRED_COMPANY_WIDTH =100
    export const GRAMMER_WIDTH =100
    export const BARRED_COLLEDGE_WIDTH =100
    export const PARSING_ERROR_WIDTH =100
    export const MISSING_SKILLS_WIDTH =200        

    export const RESUME_ANALYSIS_COLUMNS_WIDTH =[
        SN_WIDTH, ID_WIDTH, NAME_WIDTH, EMAIL_WIDTH, PHONE_WIDTH, CANDIDATE_STATUS_WIDTH,EXTRA_ANA__WIDTH,
        RESUME_STATUS_WIDTH,RESUME_SUITABILITY_WIDTH, FINAL_ANALYSIS_WIDTH,
        SKILL_ANALYSIS_WIDTH,ROLE_ANALYSIS_WIDTH,EDU_ANALYSIS_WIDTH,EXP_ANALYSIS_WIDTH,
        MENTIONED_EXP_WIDTH,CUMULATIVE_EXP_WIDTH,EXPECTED_EXP_WIDTH,
        BARRED_COMPANY_WIDTH,GRAMMER_WIDTH,BARRED_COLLEDGE_WIDTH,PARSING_ERROR_WIDTH,
        MISSING_SKILLS_WIDTH
    ]

    export const SOURCE_WIDTH =150  
    export const OWNERSHIP_WIDTH =150  
    
    export const SOURCING_TABLE_COLUMNS_WIDTH =[
        SN_WIDTH, ID_WIDTH, NAME_WIDTH, EMAIL_WIDTH, PHONE_WIDTH,
        OWNERSHIP_WIDTH,NAME_WIDTH ,ID_WIDTH,UPDATE_ON_WIDTH,SOURCE_WIDTH
    ]    

    export const NUM_MAILS =100 
    export const COMMUNICATION_COLUMNS_WIDTH =[
        SN_WIDTH, ID_WIDTH, NAME_WIDTH, EMAIL_WIDTH, PHONE_WIDTH,
        RESUME_SUITABILITY_WIDTH,CANDIDATE_STATUS_WIDTH,EXTRA_ANA__WIDTH,RESUME_STATUS_WIDTH,NUM_MAILS,NUM_MAILS,NUM_MAILS,NUM_MAILS
    ] 

    export const DETAILS_COLUMNS_WIDTH =[
        SN_WIDTH, ID_WIDTH, NAME_WIDTH, EMAIL_WIDTH, PHONE_WIDTH, CURRENT_LOCATION_WIDTH, TOTAL_EXP_WIDTH, RELEVANT_EXP_WIDTH, CURRENT_CTC_WIDTH, ECTC_WIDTH,
        NOTICE_PERIOD_WIDTH,LWD_WIDTH, COMMENTS_WIDTH,UPDATE_BY_WIDTH, UPDATE_ON_WIDTH
    ]
    export const NU_JOBS_DETAILS_COLUMNS_WIDTH =[
        SN_WIDTH, ID_WIDTH, NAME_WIDTH, EMAIL_WIDTH, PHONE_WIDTH, CURRENT_LOCATION_WIDTH, CURRENT_LOCATION_WIDTH, TOTAL_EXP_WIDTH, CURRENT_CTC_WIDTH, ECTC_WIDTH,
        NOTICE_PERIOD_WIDTH,LWD_WIDTH, NUJOBS_COMMENTS_WIDTH,UPDATE_BY_WIDTH, UPDATE_ON_WIDTH
    ]    
    export const NUJOBS_PERSONAL_DETAIL_COLUMNS_WIDTH =[
        SN_WIDTH, ID_WIDTH, NAME_WIDTH, EMAIL_WIDTH,PHONE_WIDTH, AADHAR_ID_WIDTH, GENDER_WIDTH, CURRENT_LOCATION_WIDTH,CURRENT_LOCATION_WIDTH,
        DESIGNATION_WIDTH, COMPANY_WIDTH,MAX_DEGREE_WIDTH,STREAM_WIDTH,PASSING_YEAR_WIDTH
    ]

export const EVALUATIONS_COLUMNS_WIDTH = [
  SN_WIDTH,
  ID_WIDTH,
  NAME_WIDTH,
  NAME_WIDTH,
  NAME_WIDTH,
  NAME_WIDTH,
  NAME_WIDTH,
  NAME_WIDTH,
  NAME_WIDTH,
  NAME_WIDTH,
  NAME_WIDTH,
  NAME_WIDTH,
  NAME_WIDTH,
]

export const PLANNAME_WIDTH =100  
export const NUM_WIDTH =80
export const TYPE_WIDTH =100
export const STATUS_WIDTH =100
export const SUBSCRIPTION_TABLE_COLUMNS_WIDTH =[
        CHECKBOX_WIDTH, SN_WIDTH, PLANNAME_WIDTH, NUM_WIDTH, NUM_WIDTH,,
        TYPE_WIDTH,
        STATUS_WIDTH, NUM_WIDTH,
        LWD_WIDTH, 
        LWD_WIDTH, STATUS_WIDTH+100, LWD_WIDTH, PLANNAME_WIDTH, 
        PLANNAME_WIDTH
    ]

export const SUBSCRIPTION_DETAILS_TABLE_COLUMNS_WIDTH =[
        SN_WIDTH, TYPE_WIDTH, PLANNAME_WIDTH, STATUS_WIDTH, NUM_WIDTH, LWD_WIDTH, LWD_WIDTH
    ]

export const SUBSCRIPTION_TABLE_COLUMNS_WIDTH_NU_JOBS =[
        CHECKBOX_WIDTH, SN_WIDTH, PLANNAME_WIDTH, NUM_WIDTH, NUM_WIDTH, NUM_WIDTH, NUM_WIDTH,NUM_WIDTH,
        TYPE_WIDTH,
        STATUS_WIDTH, NUM_WIDTH,
        LWD_WIDTH, 
        LWD_WIDTH, STATUS_WIDTH+100, LWD_WIDTH, PLANNAME_WIDTH, 
        PLANNAME_WIDTH
    ]